// @flow

import { logger } from './logger'

// TODO; Dominik; 18.03.2020; potential security risk; make more secure in the future
export function executeJavascript (javascript: string): void {
  try {
    // $FlowFixMe
    Function('"use strict"; ' + String(javascript))() // eslint-disable-line no-new-func
  } catch (err) {
    logger.error(err.message)
  }
}
